var map = {
	"./comment1_1.png": 13,
	"./comment1_2.png": 14,
	"./comment1_3.png": 15,
	"./comment1_4.png": 16,
	"./comment2_1.png": 17,
	"./comment2_2.png": 18,
	"./comment2_3.png": 19,
	"./comment2_4.png": 20,
	"./comment3_1.png": 21,
	"./comment3_2.png": 22,
	"./comment3_3.png": 23,
	"./comment3_4.png": 24,
	"./comment4_1.png": 25,
	"./comment4_2.png": 26,
	"./comment4_3.png": 27,
	"./comment4_4.png": 28,
	"./comment5_1.png": 29,
	"./comment5_2.png": 30,
	"./comment5_3.png": 31,
	"./comment5_4.png": 32,
	"./comment6_1.png": 33,
	"./comment6_2.png": 34,
	"./comment7_1.png": 35,
	"./comment7_2.png": 36,
	"./comment7_3.png": 37,
	"./comment7_4.png": 38
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;